/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { candidateWhatsAppMarkAsRead } from '../../axios/candidateWhatsAppMarkAsRead'
import type {
	CandidateWhatsAppMarkAsReadError,
	CandidateWhatsAppMarkAsReadPathParams,
	CandidateWhatsAppMarkAsReadRequest,
	CandidateWhatsAppMarkAsReadResponse,
} from '../../types/CandidateWhatsAppMarkAsRead'

export const candidateWhatsAppMarkAsReadMutationKey = () => [{ url: '/candidates/:candidateId/whatsapp/read' }] as const

export type CandidateWhatsAppMarkAsReadMutationKey = ReturnType<typeof candidateWhatsAppMarkAsReadMutationKey>

export type CandidateWhatsAppMarkAsReadVariables = {
	candidateId: CandidateWhatsAppMarkAsReadPathParams['candidateId']
	data: CandidateWhatsAppMarkAsReadRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/CandidateWhatsAppController.php CandidateWhatsAppController::markAsRead */
export function useCandidateWhatsAppMarkAsRead<TContext = unknown>(
	options?: UseMutationOptions<
		CandidateWhatsAppMarkAsReadResponse,
		AxiosError<CandidateWhatsAppMarkAsReadError>,
		CandidateWhatsAppMarkAsReadVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: candidateWhatsAppMarkAsReadMutationKey(),
		mutationFn: ({ candidateId, data }: CandidateWhatsAppMarkAsReadVariables) =>
			candidateWhatsAppMarkAsRead(candidateId, data, config).then(res => res.data),
		...options,
	})
}
